import {
    PLAYLIST_GET_FAIL,
    PLAYLIST_GET_SUCCESS,
    PLAYLIST_LOADING,
} from '../actions/types';

const initialState = {
    items: [],
    progress: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PLAYLIST_GET_FAIL:
            return {
                ...state,
                items: [],
                progress: false,
            };
        case PLAYLIST_GET_SUCCESS:
            return {
                ...state,
                items: action.payload,
                progress: false,
            };
        case PLAYLIST_LOADING:
            return {
                ...state,
                progress: true,
            };
        default:
            return state;
    }
};

export default reducer;
